<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    (closeButtonActionEmt)="closeModal()">

    <div class="modal-row-column-auto header-timezone ">
        <span>Time Zone</span>
    </div>

    <div class="modal-row-column-auto filterClass">
        <res-filter data-automation-id="tags-filter-input" [maxChars]=32 [placeholder]='"Filter ..."'
            [callback]="filterData.bind(this)"></res-filter>
    </div>

    <res-generic-grid gridName="Timezone" [automationId]="modalAutomationId" [pagerVisible]="false"
        [columnDefs]="columnDefs" [requestInfo]="requestInfo" [headerHeight]="0"
        [responseArrayCallback]="responseArrayCallback" [rowSelection]="rowSelection"
        [loadDataFinishedCallback]="loadDataFinishedCallback">
    </res-generic-grid>

</res-base-modal>